import axios from "../../axios";

const BASE_URL = "/organization-questionnaires";

const api = {
  // CATEGORY 11
  importUseOfSoldProducts({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`${BASE_URL}/${questionnaireId}/use-of-sold-products/import`, data, headers).then(({data}) => data);
  },

  updateUseOfSoldProducts({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`${BASE_URL}/${questionnaireId}/use-of-sold-products`, data, headers).then(({data}) => data);
  },

  getUseOfSoldProductsTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/use-of-sold-products/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Scope3_Category11_template";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;
